<template>
    <div class="home">

        <pageheader text="Innstillinger"/>


        <b-form @submit="onSubmit">


            <section>
                <h4>Navn</h4>

                <b-form-group description="">
                    <b-form-input disabled placeholder="Fullt navn" v-model="form.name" trim></b-form-input>
                </b-form-group>

                <b-form-group description="">
                    <b-form-input disabled placeholder="Kallenavn" v-model="form.nickname" trim></b-form-input>
                </b-form-group>

            </section>


            <section>
                <h4>Adresse</h4>

                <b-form-group>
                    <b-form-input disabled placeholder="Adresse" v-model="form.address" trim></b-form-input>
                </b-form-group>

                <b-form-group description="">
                    <b-input-group>
                        <b-form-input disabled placeholder="By" v-model="form.city" trim></b-form-input>
                        <b-form-input disabled placeholder="Postnummer" v-model="form.zip" trim></b-form-input>
                    </b-input-group>
                </b-form-group>

            </section>

            <section>
                <h4>Kontaktinfo</h4>

                <b-form-group description="">
                    <b-form-input disabled placeholder="E-post" v-model="form.email" trim></b-form-input>
                </b-form-group>

                <b-form-group description="">
                    <b-form-input disabled placeholder="Telefon" v-model="form.phone" trim></b-form-input>
                </b-form-group>

            </section>

            <section>
                <h4>SMS-kommunikasjon</h4>

                <b-form-group description="Minimumsbeløp for at vi skal si ifra til deg per SMS når du vinner">
                    <b-form-input  placeholder="SMS Minimum beløp" v-model="form.sms_min_price" trim number></b-form-input>
                </b-form-group>

                <b-form-group description="Ønsker du å motta informasjon per SMS"  >
                    <b-form-checkbox v-model="form.sms_advertising" value="1" unchecked-value="0">SMS informasjon</b-form-checkbox>
                </b-form-group>
            </section>

            <!-- <section>
                    <h4>Kommunikasjon</h4>

                    <b-form-group description=""  >
                    <b-form-input disabled placeholder="E-post" v-model="form.email" trim></b-form-input>
                </b-form-group>

            </section> -->

            <section>
                <h4>Bankkonto</h4>

                <b-form-group description="Bankkontonummer for utbetaling" v-if="form.bankaccount">
                    <b-input-group :prepend="bankName" class="mt-3">
                        <b-form-input disabled placeholder="Bankkontonummer" v-model="form.bankaccount" trim></b-form-input>
                        <b-input-group-append>
                            <b-button variant="danger" @click="removeBankaccount()">Legg inn et annet</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>

                <b-button  variant="secondary" to="/bankkonto" v-else>Legg inn bannkkonto</b-button>

            </section>

            <section>
                <h4>Pin</h4>

                <b-form-group description="Skriv inn ny pin her, den gamle vises ikke" :invalid-feedback="fourDigitsFeedback(form.pin)" :state="fourDigits(form.pin)">
                    <b-form-input type="password" autocomplete="off" placeholder="Pin, 4 siffer" pattern="\d{4}" v-model="form.pin" :state="fourDigits(form.pin)" trim></b-form-input>
                </b-form-group>
            </section>





            <hr v-if="errors.length">

            <b-alert show variant="danger" v-if="errors.length" class="errors">
                <ul>
                    <li  v-for="error in errors" :key="error">
                        {{ error }}
                    </li>
                </ul>
            </b-alert>

            <b-alert show variant="secondary" class="errors" v-if="messages.length">
                <ul>
                    <li  v-for="msg in messages" :key="msg">
                        {{ msg }}
                    </li>
                </ul>
            </b-alert>



            <br>

            <loading-button :disabled="formDisabled" >Lagre</loading-button>

        </b-form>

        <p class="text-muted mt-4">
            For å endre resten av personopplysningene dine må du besøke din bingohall.
        </p>




    </div>
</template>

<script>
// @ is an alias to /src
import LoadingButton from '@/components/LoadingButton.vue';

export default {
    name: 'Settings',
    components: {
        LoadingButton
    },
    data() {
        return {
            amounts: [
                100,
                200,
                500,
                1000,
                2000
            ],
            form: {
                nickname: null,
                name: null,

                address: null,
                city: null,
                zip: null,

                phone: null,
                email: null,

                sms_min_price: null,
                sms_advertising: null,

                bankaccount: null,

                pin: null
            },
            errors:[],
            messages: [],
            formDisabled: false
        }
    },
    mounted() {

        this.$api.get(`/users/${this.$store.getUser().card_id}/`)
        .then((response) => {
            // Fil form
            let o = Object.assign(this.form, response.data.data);

            this.bank = this.form.bankaccount
        })
        .catch((response) => {
            console.log(response);
        });


    },
    methods: {

        onSubmit(e) {
            e.preventDefault()

            this.errors = [];
            this.messages = [];


            if (this.errors.length) return;

            var data = {
                "name": this.form.name,
                "nickname": this.form.nickname,
                "address": this.form.address,
                "city": this.form.city,
                "zip": this.form.zip,
                "phone": this.form.phone,
                "email": this.form.email,
                "sms_min_price": this.form.sms_min_price,
                "sms_advertising": this.form.sms_advertising
            };

            if (this.fourDigits(this.form.pin)) data.pin = this.form.pin;

            this.formDisabled = true;

            this.$api.put(`/users/${this.$store.getUser().card_id}/`, data)
            .then((response) => {
                this.messages.push('Informasjonen er oppdatert.');
                this.formDisabled = false;
            })
            .catch((error) => {
                console.log(error);
                if (error.response) {
                    let code = error.response.status;
                    switch (code) {
                        case 403:  this.errors.push('Du er blokkert og kan derfor ikke endre info.'); break;
                        default:   this.errors.push('Noe gikk galt under lagringen.'); break;
                    }
                }
                else {
                    this.errors.push('Noe gikk galt under lagringen.');
                }
                this.formDisabled = false;
            });


        },

        removeBankaccount() {
            this.$api.delete(`/users/${this.$store.getUser().card_id}/bankaccount/`)
            .then((response) => {
                this.form.bankaccount = null;
            })
            .catch((response) => {
                console.log(response);
            });
        },

        fourDigits(s) {
            return (s === null || s === '') ? null : /^(\d\d\d\d)$/.test(s);
        },
        fourDigitsFeedback(s) {
            if (s === null || s === '') return '';
            else if (!/^(\d\d\d\d)$/.test(s)) return 'Koden må ha fire siffer';
            else return 'Tast inn noe';
        },

    },
    computed: {
        bankName: function() {
            return this.getBankName(this.form.bankaccount);
        }
    }
}
</script>



<style lang="scss" scoped>
section {
    margin-bottom: 4em;
}

.errors ul {
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;
}

</style>
